import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { PlayerService } from 'src/app/shared/player.service';
import { User } from 'src/app/shared/user.model';
import { UserService } from 'src/app/shared/user.service';
import { Objective, ObjectiveTask } from '../../models/objectives';
import { ObjectivesService } from '../../services/objectives.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-edit-task-dialog',
    templateUrl: './edit-task-dialog.component.html',
    styleUrls: ['./edit-task-dialog.component.css'],
    imports: [ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton, MatDialogClose]
})
export class EditTaskDialogComponent implements OnInit {

 
  taskForm;
  users: User[];
  ObjectiveTask: ObjectiveTask;

  constructor(private fb: UntypedFormBuilder,
    private playerService: PlayerService,
    private objectiveService: ObjectivesService,
    private userService: UserService,
    public dialogRef: MatDialogRef<EditTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {ObjectiveTask: ObjectiveTask}) { }

  ngOnInit(): void {

    this.ObjectiveTask = this.data.ObjectiveTask;
    console.log(this.ObjectiveTask);
    this.userService.getAllUsers().subscribe(data=>{
      this.users =  data as User[];
    });

    this.taskForm = this.fb.group({
      ObjectiveId: [this.ObjectiveTask.ObjectiveId],
      TaskId: [this.ObjectiveTask.TaskId],
      Owner: [this.ObjectiveTask.Owner, [Validators.required]],
      Title: [this.ObjectiveTask.Title,[Validators.required]],
      Description: [this.ObjectiveTask.Description,[Validators.required]],      
      TargetDate: [this.ObjectiveTask.TargetDate,[Validators.required]],

      
    });

   
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    /* console.warn(this.taskForm.value);
    console.log(this.taskForm.valid); */
    this.objectiveService.updateTask(this.taskForm.value).subscribe(res=>{
      this.dialogRef.close();
    });
  }

}
